module.exports = __webpack_public_path__ + "static/media/Nokia Asha 230 Yellow.12d3b986.png";